/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgFlagItem } from './OrgFlagItem';
import {
    OrgFlagItemFromJSON,
    OrgFlagItemFromJSONTyped,
    OrgFlagItemToJSON,
    OrgFlagItemToJSONTyped,
} from './OrgFlagItem';

/**
 * 
 * @export
 * @interface OrgFlagsListResponse
 */
export interface OrgFlagsListResponse {
    /**
     * 
     * @type {Array<OrgFlagItem>}
     * @memberof OrgFlagsListResponse
     */
    flags: Array<OrgFlagItem>;
}

/**
 * Check if a given object implements the OrgFlagsListResponse interface.
 */
export function instanceOfOrgFlagsListResponse(value: object): value is OrgFlagsListResponse {
    if (!('flags' in value) || value['flags'] === undefined) return false;
    return true;
}

export function OrgFlagsListResponseFromJSON(json: any): OrgFlagsListResponse {
    return OrgFlagsListResponseFromJSONTyped(json, false);
}

export function OrgFlagsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgFlagsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'flags': ((json['flags'] as Array<any>).map(OrgFlagItemFromJSON)),
    };
}

  export function OrgFlagsListResponseToJSON(json: any): OrgFlagsListResponse {
      return OrgFlagsListResponseToJSONTyped(json, false);
  }

  export function OrgFlagsListResponseToJSONTyped(value?: OrgFlagsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flags': ((value['flags'] as Array<any>).map(OrgFlagItemToJSON)),
    };
}

